import { render, staticRenderFns } from "./PIDConfigPanel.vue?vue&type=template&id=38733392"
import script from "./PIDConfigPanel.vue?vue&type=script&lang=js"
export * from "./PIDConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./PIDConfigPanel.vue?vue&type=style&index=0&id=38733392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports